import './MainPageSub04_2.scss';
import React, { useEffect } from 'react';
import MainPageSub04_2graph from '../page_home/MainPageSub04_2graph';

const MainPageSub04_2 = ({barData, eveluationIndexP, eveluationIndexDescription}) => {

    // const barData = [
    //     { label: "동기부여", score: 90 },
    //     { label: "목표의식", score: 80 },
    //     { label: "독서력", score: 65 },
    //     { label: "독해력", score: 53 },
    //     { label: "어휘력", score: 50 },
    //     { label: "표현력", score: 55 },
    //     { label: "주도력", score: 75 }
    //   ];
    
    //====================================================================
    return (
        <div className="MainPageSub04_2">
            <section className='sec-main'>
                <section className='sec-sub1'>     
                    <article className='art-main-graph'>
                        <p className="heading-3 title2">공부력을 좌우하는 것은 바로 이것이다!</p>
       
                        <ul className="analysis-list">
                            <li><mark>동기부여</mark>ㅣ진로기반의 집중력/멘탈관리능력</li>
                            <li><mark>목표의식</mark>ㅣ계획력/이행력/몰입능력</li>
                            <li><mark>독서력</mark>ㅣ빠르게 읽고 이해하는 능력</li>
                            <li><mark>독해력</mark>ㅣ문장과 지문을 분석하고 적용하는 문제집착능력</li>
                            <li><mark>어휘력</mark>ㅣ교과영역 전반을 확장 독해하는 문제처리 속도능력</li>
                            <li><mark>표현력</mark>ㅣ글(논술)과 말(구술)로 임팩트 있게 서술하고 정리하는 능력</li>
                            <li><mark>주도력</mark>ㅣ루틴과 습관을 이행하는 시간관리능력/지속력/지구력/관계력/소통능력</li>
                        </ul>
                     

                    </article>

                    <article className='art-main'>
                            <MainPageSub04_2graph barData={barData} />
                    </article>

                 
                  
                </section>

                <article className='art-evalutionIndex'>
                    <span>평가지수 : {eveluationIndexP}</span>
                    <span>{eveluationIndexDescription}</span>
                </article>
              
            </section>
        </div>
    );
};

export default MainPageSub04_2;
